import axios, { AxiosRequestConfig } from "axios";
import { ADMIN_API_BASE } from "./adminApiConfig";

/** Datum izvlačenja glavne nagrade — tabela ultra_g_{date} */
export const MAIN_PRIZE_DATE = "20261012";

const getWinner = async (date: string = MAIN_PRIZE_DATE): Promise<any> => {
  try {
    const config: AxiosRequestConfig = {
      method: "GET",
      // url: `https://test-back.firebird.rs/api/ultra/winners-m`,
      url: `${ADMIN_API_BASE}/api/ultra/winners-m`,
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        date,
      },
    };

    const response = await axios(config);
    const { data } = response;
    const { code } = data;

    if (code !== 200) {
      return [];
    }

    return data.data;
  } catch (error) {
    return [];
  }
};

export default getWinner;
